import { render } from "./ticket-view.vue?vue&type=template&id=05a0de8e"
import script from "./ticket-view.vue?vue&type=script&lang=js"
export * from "./ticket-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__